export default __webpack_public_path__ + "static/media/product-icon.713a22c2.svg";